// Lỗi validate dòng trả nguyên dòng Excel (key 'C'/'D' hoặc 2/3) thay vì { user_name, activation_code }
export const getErrorRowInfo = (data: any) => ({
  userName: data?.user_name ?? data?.C ?? data?.[2] ?? '',
  activationCode: data?.activation_code ?? data?.D ?? data?.[3] ?? '',
});

export interface ActivationPreviewRow {
  line: number; // dòng trong Excel, khớp số dòng server báo lỗi
  name: string;
  userName: string;
  code: string;
}

// Mỗi mã chỉ kích hoạt cho một tài khoản: mã xuất hiện ở nhiều dòng thì trả các dòng đó để cảnh báo trước khi tải lên
export const findDuplicateCodes = (rows: ActivationPreviewRow[]): Map<string, number[]> => {
  const lines = new Map<string, number[]>();
  rows.forEach(({ code, line }) => {
    if (code) lines.set(code, [...(lines.get(code) ?? []), line]);
  });
  return new Map(Array.from(lines).filter(([, found]) => found.length > 1));
};
